"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertSizeOrPositionUpdateIsValid;
const either_1 = require("../../../../types/either");
function assertSizeOrPositionUpdateIsValid(layer, layerUpdates) {
  const layerMoving = !isNaN(Number(layerUpdates.x)) || !isNaN(Number(layerUpdates.y));
  const layerResizing = !isNaN(Number(layerUpdates.width)) || !isNaN(Number(layerUpdates.height));
  /* NOTE: Strictly speaking, this check is incorrect; it means that if ONE operation is allowed, then BOTH operations
   * are allowed. That said, we've spoken to product about it and they don't care, because the two booleans
   * (userCanResize and userCanMove) are unlikely to ever be different (they'll always be both on or both off).
   *
   * Q: Why not just fix it anyway?
   * A: To fix it requires restructuring how all of this is setup. All the permutations cannot be encapsulated in a single
   * boolean, so we would have to change this method to return an object type that just has the allowed properties on it,
   * then update all consumers. We would also have to fix `updatePrintableLayerPosition.ts`, which has this broken logic as well.
   * In sum: the juice is not worth the squeeze right now.
   *
   * - Wohletz, APR-16-2024
   */
  const isSizeOrPositionUpdateValid = !(layerMoving || layerResizing) || layerMoving && layer.userCanMove || layerResizing && layer.userCanResize;
  if (!isSizeOrPositionUpdateValid) {
    return (0, either_1.left)(new Error(`Action is invalid for layer; layerMoving: ${layerMoving}, userCanMove: ${layer.userCanMove}, layerResizing: ${layerResizing}, userCanResize: ${layer.userCanResize}`));
  }
  return (0, either_1.right)(null);
}